import React from "react";
import "graphiql/graphiql.min.css";
import Ide from "./Ide";

const App = () => <Ide></Ide>;

export default App;
